<template>
  <div class="row">
    <div class="col-sm-12 text-center" v-if="type == 1">
      <div class="alert alert-light border-yellow" role="alert">
        <h4 class="info-text">
          <strong>
            Welcome to our live events and webinars with expert hosts</strong
          >
        </h4>
        Register in advance for our informative webinars and virtual events.
        Hear from expert guest speakers from tried and tested services that you
        can count on.
      </div>
    </div>
    <div class="col-sm-12 text-center" v-if="type == 2">
      <div class="alert alert-light border-yellow" role="alert">
        <h4 class="info-text">
          <strong>Meet our partner</strong>
          <div class="m-t-20 smart-logo">
            <img src="/assets/img/logo.png" title="Smart currency exchange" />
          </div>
        </h4>
        Your property purchase is likely to require a currency transaction. We
        have teamed up with Smart Currency Exchange to help overseas property
        buyers successfully purchase and pay for their overseas property.
      </div>
    </div>
    <!-- thank you YOH-->
    <div class="col-sm-12 text-center m-t-20" v-if="type == 3">
      <div class="alert alert-light border-blue" role="alert">
        <fresh-relevance-pixel
          :email="email"
          :orderReference="orderReference"
        />
        <div class="yoh-logo">
          <img src="/assets/img/yoh-logo.png" title="Your overseas home" />
        </div>
        <h4 class="info-text">
          <strong>
            Thank you for signing up to our Webinar or Virtual event, we look
            forward to seeing you there!</strong
          >
        </h4>
        <div class="alert alert-info text-center" role="alert">
          <b
            >You will now receive an email confirmation containing all the
            information you need to access the upcoming webinar</b
          >
        </div>
      </div>
    </div>
    <!-- thank you SMART-->
    <div class="col-sm-12 text-center m-t-20" v-if="type == 4">
      <div class="alert alert-light border-blue" role="alert">
        <div class="smart-logo">
          <img
            src="/assets/img/success-checked-100.png"
            title=""
            style="width:100px;"
          />
        </div>
        <h4 class="info-text">
          <strong>
            Thank you for your interest in Smart Currency Exchange via Your
            Overseas Home.</strong
          >
        </h4>
        <div class="alert text-center" role="alert">
          <p>
            We are processing your application and hope to have your account
            open shortly.
          </p>
        </div>
      </div>
    </div>
    <!-- virtual event info -->
    <div class="col-sm-12 text-center m-t-20" v-if="type == 5">
      <div class="alert alert-light border-blue" role="alert">
        <!-- <h4 class="info-text">
          <strong>
            Thank you for your interest in Smart Currency Exchange via Your Overseas Home.</strong
          >
        </h4> -->
        <div class="alert text-center" role="alert">
          <p><strong>What you'll gain</strong></p>
          <p>
            Get expert guidance for your overseas property plans — covering tax,
            visas, residency, and the buying process. Learn from trusted
            specialists with 20+ years' experience helping international buyers
            move forward with confidence.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FreshRelevancePixel from "@/components/freshRelevance/FreshRelevancePixel.vue";

export default {
  name: "MessageTemplate",
  components: {
    "fresh-relevance-pixel": FreshRelevancePixel,
  },
  props: {
    type: {
      type: Number,
      required: true,
    },
    email: {
      type: String,
      default: "",
    },
    orderReference: {
      type: String,
      default: "",
    },
  },
};
</script>
<style scoped>
.border-yellow {
  border: 2px solid #fbaa19;
}
.border-blue {
  border: 2px solid #0c75bb;
}
.m-t-20 {
  margin-top: 20px;
}
.yoh-logo img {
  width: 200px;
}
.smart-logo img {
  width: 170px;
}
</style>
